export const UnsupportedType = ({__typename}: {__typename: string}) => <div>{__typename} currently not supported.</div>
